import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "filter-overview easy-drop full-mobile" }
const _hoisted_2 = {
  class: "mobile-filter",
  hidden: ""
}
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" • ")
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "drop-content" }
const _hoisted_8 = { class: "drop-header" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "drop-content-center" }
const _hoisted_11 = {
  key: 0,
  class: "stars"
}
const _hoisted_12 = ["id", "value", "disabled", "checked", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 1,
  class: "categories"
}
const _hoisted_15 = ["value", "checked", "onChange"]
const _hoisted_16 = {
  for: "searchHotel",
  class: "sr-only"
}
const _hoisted_17 = { class: "search-input" }
const _hoisted_18 = ["placeholder", "value"]
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  class: "drop-footer",
  hidden: ""
}
const _hoisted_21 = { class: "space-wrapper" }
const _hoisted_22 = {
  type: "button",
  class: "link-btn"
}
const _hoisted_23 = { class: "filter-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyMultiRangeSlider = _resolveComponent("EasyMultiRangeSlider")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "/",
          class: "back-btn",
          title: _ctx.pageTexts['hotelListPageSearchFilterButtonBackTitle']
        }, null, 8, _hoisted_3),
        _createElementVNode("span", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['destination']), 1),
          (_ctx.searchTravelRequest.dateFrom && _ctx.searchTravelRequest.dateTo)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.searchTravelRequest.dateFrom)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.searchTravelRequest.dateTo)), 1)
              ], 64))
            : _createCommentVNode("", true),
          _createTextVNode(" • " + _toDisplayString(_ctx.adultsCount) + " " + _toDisplayString(_ctx.adultSinglePlural(_ctx.adultsCount)) + " ", 1),
          (_ctx.childrenCount > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" , " + _toDisplayString(_ctx.childrenCount) + " " + _toDisplayString(_ctx.childSinglePlural(_ctx.childrenCount)), 1)
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_4,
          _createElementVNode("abbr", null, _toDisplayString(_ctx.selectedAirport?.id), 1)
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["filter-btn", { active: _ctx.isActive }]),
        title: _ctx.pageTexts['hotelListPageSearchFilterButtonOpenTitle'],
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
      }, null, 10, _hoisted_5)
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["drop-open", { active: _ctx.isActive }]),
      title: _ctx.pageTexts['hotelListPageSearchFilterButtonOpenTitle'],
      hidden: ""
    }, null, 10, _hoisted_6),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "back-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args))),
          title: _ctx.pageTexts['hotelListPageSearchFilterButtonCloseTitle'],
          hidden: ""
        }, null, 8, _hoisted_9),
        _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchFilterHeadline']), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.filter.stars.length)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_11, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchFilterLabelNumberOfHotelStars']), 1),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.stars, (star, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("input", {
                      id: 'star' + star.id,
                      type: "checkbox",
                      name: "filterStars",
                      value: star.id,
                      disabled: star.disabled,
                      checked: star.selected,
                      onChange: ($event: any) => (_ctx.updateFilterStars($event, index))
                    }, null, 40, _hoisted_12),
                    _createElementVNode("label", {
                      for: 'star' + star.id
                    }, _toDisplayString(star.id), 9, _hoisted_13)
                  ], 64))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filter.categories.length)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_14, [
              _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchFilterLabelCategories']), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.categories, (category, index) => {
                return (_openBlock(), _createElementBlock("label", {
                  class: "standard",
                  key: index
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "filterCategories",
                    value: category.id,
                    checked: category.selected,
                    onChange: ($event: any) => (_ctx.updateFilterCategories($event, index))
                  }, null, 40, _hoisted_15),
                  _createElementVNode("span", null, _toDisplayString(category.name) + " (" + _toDisplayString(category.count) + ")", 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_EasyMultiRangeSlider, {
          customClass: 'price-range',
          label: _ctx.pageTexts['hotelListPageSearchFilterLabelTotalTravelPrice'] + '<small>' + _ctx.pageTexts['hotelListPageSearchFilterLabelTotalTravelPriceSubtext'] + '</small>',
          inputPostfix: 'kr.',
          minValue: _ctx.filter.minPrice,
          maxValue: _ctx.filter.maxPrice,
          maxId: 'filterMaxPrice',
          minId: 'filterMinPrice',
          maxLabel: _ctx.pageTexts['hotelListPageSearchFilterLabelTotalTravelPriceMax'],
          minLabel: _ctx.pageTexts['hotelListPageSearchFilterLabelTotalTravelPriceMin'],
          minValueAvailable: _ctx.filter.minPriceAvailable,
          maxValueAvailable: _ctx.filter.maxPriceAvailable,
          step: 100,
          localeStrings: _ctx.localeStrings,
          onSliderUpdate: _ctx.updatePriceRange,
          onMinValueUpdate: _ctx.updateFilterMinimumPrice,
          onMaxValueUpdate: _ctx.updateFilterMaximumPrice,
          formatToCurrency: true
        }, null, 8, ["label", "inputPostfix", "minValue", "maxValue", "maxLabel", "minLabel", "minValueAvailable", "maxValueAvailable", "localeStrings", "onSliderUpdate", "onMinValueUpdate", "onMaxValueUpdate"]),
        _createElementVNode("fieldset", null, [
          _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelListPageSearchFilterLabelSearchForHotel']), 1),
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.pageTexts['hotelListPageSearchFilterLabelSearchForHotel']), 1),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("input", {
              id: "searchHotel",
              type: "search",
              placeholder: _ctx.pageTexts['hotelListPageSearchFilterLabelSearchForHotelPlaceholder'],
              value: _ctx.filter.query,
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateFilterQuery && _ctx.updateFilterQuery(...args))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.updateFilterQuery && _ctx.updateFilterQuery(...args)), ["enter"]))
            }, null, 40, _hoisted_18),
            _createElementVNode("button", {
              title: _ctx.pageTexts['hotelListPageSearchFilterButtonQuerySearchTitle'],
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateFilterQuery && _ctx.updateFilterQuery(...args)))
            }, null, 8, _hoisted_19)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonReset']), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
          }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonSave']), 1)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_23, null, 512), [
        [_vShow, _ctx.isIdle]
      ])
    ])
  ]))
}